module.exports = __webpack_public_path__ + "static/media/marketing-analytics.2fb96497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/services/marketing-analytics.svg
// module id = 1264
// module chunks = 0